var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "agreement_policy"
  }, [_c('div', {
    attrs: {
      "id": "wordView"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.vHtml)
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };